import React from "react";
import { isTikTokConfigured } from "../../features/tiktok/config/tiktokEnv";

interface StatusFilterProps {
  selectedStatus: string;
  onChange: (status: string) => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatus,
  onChange,
}) => {
  // Define common post statuses
  const statuses = [
    { value: "", label: "All Statuses" },
    { value: "PENDING", label: "Pending" },
    { value: "APPROVED", label: "Approved" },
    { value: "PUBLISHED", label: "Published" },
    // Dormant until TikTok is configured (SGL-170).
    ...(isTikTokConfigured() ? [{ value: "SENT_TO_TIKTOK", label: "Sent to TikTok" }] : []),
    { value: "FAILED", label: "Failed" },
  ];

  // Get status badge color based on status
  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "bg-yellow-100 text-yellow-800";
      case "approved":
        return "bg-green-100 text-green-800";
      case "published":
        return "bg-blue-100 text-blue-800";
      case "sent_to_tiktok":
        return "bg-sky-100 text-sky-800";
      case "failed":
        return "bg-red-100 text-red-800";
      default:
        return "bg-theme-border/40 text-theme-fg";
    }
  };

  return (
    <div className="flex flex-col">
      <label className="mb-2 block text-sm font-medium text-theme-fg">
        Status
      </label>
      <div className="flex flex-wrap gap-2">
        {statuses.map((status) => (
          <button
            key={status.value}
            type="button"
            onClick={() => onChange(status.value)}
            className={`px-3 py-1.5 text-sm rounded-full transition-colors ${
              selectedStatus === status.value
                ? "bg-brand-primary text-white"
                : status.value
                ? getStatusColor(status.value)
                : "bg-surface-ui text-theme-fg hover:bg-surface-ui-hover"
            }`}
          >
            {status.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StatusFilter;
